import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from '@material-ui/core/styles';

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    color: 'white !important',
  },
}))(Tooltip);

const ReportLink = ({ links = [] }) => {
  const htmlLinks = links.filter(link => link.type === "html");
  const pdfLinks = links.filter(link => link.type === "pdf");

  return (
    <div className="report-links">
      {htmlLinks.length > 0 && (
        <>
          <div className="language-buttons">
            {htmlLinks.map((link, i) => (
              <CustomTooltip key={i} title={link.language} placement="top">
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lang-btn"
                  style={{ width: "max-content", textAlign: "center"}}
                >
                  <p>{link.languageCode}</p>
                  <p style={{fontSize: "8px"}}>HTML</p>
                </a>
              </CustomTooltip>
            ))}
          </div>
        </>
      )}

      {pdfLinks.length > 0 && (
        <>
          <div className="language-buttons">
            {pdfLinks.map((link, i) => (
              <CustomTooltip key={i} title={link.language} placement="top">
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lang-btn"
                  style={{ width: "max-content" }}
                  {...(link.download ? { download: true } : {})}
                >
                  <p>{link.languageCode}</p>
                  <p style={{fontSize: "8px"}}>PDF</p>
                </a>
              </CustomTooltip>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ReportLink;
